import React from 'react';
import '../styles/global.scss';
import Layout from '../components/Layout/Layout';
var Contact = function Contact() { return /*#__PURE__*/ React.createElement(React.Fragment, null, "Contact Page"); };
Contact.Layout = Layout;
export default Contact;
